import React from 'react';
import Moment from 'react-moment';
import 'moment-timezone';
import PropTypes from 'prop-types';

const RemeetingTimestamp = ({ date, format }) => (
  <Moment format={format} date={date} />
);

RemeetingTimestamp.propTypes = {
  date: PropTypes.string,
  format: PropTypes.string,
};

RemeetingTimestamp.defaultProps = {
  date: '',
  format: 'YYYY-MM-DD hh:mm:ss A',
};

export default RemeetingTimestamp;
